// src/Dashboard/pages/teacher/SuiviCompetitions/components/SuiviCompetitionsFiltersCard.jsx

import React, { useEffect, useState } from "react";
import { FaFilter, FaSearch, FaTimes, FaUserCheck } from "react-icons/fa";

import { CATE_EVENTS } from "../utils/suiviCompetitionsUtils";

export default function SuiviCompetitionsFiltersCard({
  filters,
  setFilters,
  eventTypes = [],
  loading,
  onReset,
}) {
  const [localSearch, setLocalSearch] = useState(filters.search || "");

  useEffect(() => {
    setLocalSearch(filters.search || "");
  }, [filters.search]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setFilters({ search: localSearch });
    }, 250);

    return () => clearTimeout(timer);
  }, [localSearch, setFilters]);

  const fieldClass =
    "w-full rounded-xl border border-slate-300 bg-white px-3 py-2 text-sm text-slate-900 outline-none transition focus:ring-2 focus:ring-violet-400 disabled:opacity-60 dark:border-slate-700 dark:bg-slate-900 dark:text-slate-100";

  const labelClass =
    "mb-1 block text-xs font-semibold text-slate-700 dark:text-slate-300";

  return (
    <section className="rounded-[28px] border border-slate-200 bg-white p-4 shadow-sm dark:border-slate-800 dark:bg-slate-900">
      <div className="mb-4 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <div>
          <div className="inline-flex items-center gap-2 text-sm font-bold text-slate-800 dark:text-slate-100">
            <FaFilter />
            Filtres compétitions
          </div>

          <p className="mt-1 text-xs text-slate-500 dark:text-slate-400">
            Recherchez par nom, filtrez par date, catégorie, type ou uniquement
            les événements avec inscrits.
          </p>
        </div>

        <button
          type="button"
          onClick={onReset}
          className="inline-flex items-center justify-center gap-2 rounded-xl bg-slate-100 px-3 py-2 text-xs font-bold text-slate-700 transition hover:bg-slate-200 dark:bg-slate-800 dark:text-slate-200 dark:hover:bg-slate-700"
        >
          <FaTimes />
          Réinitialiser
        </button>
      </div>

      <div className="grid grid-cols-1 gap-3 md:grid-cols-2 xl:grid-cols-5">
        <div className="xl:col-span-2">
          <label className={labelClass}>Recherche</label>

          <div className="relative">
            <FaSearch className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />

            <input
              type="text"
              value={localSearch}
              onChange={(event) => setLocalSearch(event.target.value)}
              disabled={loading}
              placeholder="Coupe, Open, championnat, animation..."
              className="w-full rounded-xl border border-slate-300 bg-white py-2 pl-9 pr-3 text-sm text-slate-900 outline-none transition focus:ring-2 focus:ring-violet-400 disabled:opacity-60 dark:border-slate-700 dark:bg-slate-900 dark:text-slate-100"
            />
          </div>
        </div>

        <div>
          <label className={labelClass}>Date</label>

          <select
            value={filters.dateFilter}
            onChange={(event) => setFilters({ dateFilter: event.target.value })}
            disabled={loading}
            className={fieldClass}
          >
            <option value="all">Toutes</option>
            <option value="upcoming">À venir</option>
            <option value="past">Passées</option>
          </select>
        </div>

        <div>
          <label className={labelClass}>Catégorie</label>

          <select
            value={filters.categoryFilter}
            onChange={(event) =>
              setFilters({ categoryFilter: event.target.value })
            }
            disabled={loading}
            className={fieldClass}
          >
            <option value="">Toutes</option>
            {CATE_EVENTS.map((category) => (
              <option key={category} value={category}>
                {category}
              </option>
            ))}
          </select>
        </div>

        <div>
          <label className={labelClass}>Type</label>

          <select
            value={filters.typeFilter}
            onChange={(event) => setFilters({ typeFilter: event.target.value })}
            disabled={loading}
            className={fieldClass}
          >
            <option value="">Tous</option>
            {eventTypes.map((type) => (
              <option key={type} value={type}>
                {type}
              </option>
            ))}
          </select>
        </div>
      </div>

      <div className="mt-4 flex flex-wrap items-center gap-2">
        <button
          type="button"
          onClick={() =>
            setFilters({
              onlyWithRegistrations: !filters.onlyWithRegistrations,
            })
          }
          className={`inline-flex items-center gap-2 rounded-xl px-3 py-2 text-xs font-bold ring-1 transition ${
            filters.onlyWithRegistrations
              ? "bg-emerald-50 text-emerald-700 ring-emerald-200 dark:bg-emerald-900/20 dark:text-emerald-200 dark:ring-emerald-800/60"
              : "bg-slate-100 text-slate-600 ring-slate-200 hover:bg-slate-200 dark:bg-slate-800 dark:text-slate-300 dark:ring-slate-700 dark:hover:bg-slate-700"
          }`}
        >
          <FaUserCheck />
          <span
            className={`h-2 w-2 rounded-full ${
              filters.onlyWithRegistrations ? "bg-current" : "bg-slate-400"
            }`}
          />
          Uniquement avec inscrits
        </button>
      </div>
    </section>
  );
}